import React from 'react'

import CurrencySelector from '@/atoms/CurrencySelector/CurrencySelector'
import { useTranslation } from '@/lib/i18n/i18n'
import { getCurrencySign } from '@/lib/number-utils'
import { AppBarMobileCollapse } from '@/organisms/AppBar/AppBar.components'

import { useCurrencySelector } from './useCurrencySelector'

export const CurrencySelectorCollapse: React.FC = () => {
	const { t } = useTranslation()
	const { currency, onChange } = useCurrencySelector()

	return (
		<AppBarMobileCollapse
			title={
				<>
					<span>{getCurrencySign(currency)}</span>
					<span>{t('locale-selector.currency')}</span>
				</>
			}
		>
			<CurrencySelector currency={currency} onChange={onChange} />
		</AppBarMobileCollapse>
	)
}
